module.exports = __webpack_public_path__ + "static/Leschke-Kahle-28c96a368834ae4bc8b83f16fbad79cd.jpg";